import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Check } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 bg-white" data-id="element-67">
      <div className="max-w-4xl mx-auto px-6" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-12 rounded-3xl shadow-2xl text-center" data-id="element-69">
          <div className="bg-gradient-to-br from-rose-100 to-pink-100 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-70">
            <Shield className="w-12 h-12 text-rose-600" data-id="element-71" />
          </div>

          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-72">
            Garantia de Satisfação Total
          </h2>

          <p className="text-2xl text-gray-700 mb-8 leading-relaxed" data-id="element-73">
            Se você não achar{' '}
            <span className="font-bold text-rose-600" data-id="element-74">
              pelo menos 5 ideias lindas
            </span>{' '}
            e possíveis de fazer, devolvo{' '}
            <span className="font-bold" data-id="element-75">100% do valor</span>.
          </p>

          <div className="bg-gradient-to-br from-rose-50 to-pink-50 p-8 rounded-2xl mb-8" data-id="element-76">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-77">
              Por que essa garantia existe?
            </h3>

            <div className="space-y-4 text-left" data-id="element-78">
              <div className="flex items-start gap-4" data-id="element-79">
                <Check className="w-6 h-6 text-rose-600 flex-shrink-0 mt-1" data-id="element-80" />
                <p className="text-lg text-gray-700" data-id="element-81">
                  Porque eu sei que o guia funciona. Dezenas de noivas já usaram
                  e aprovaram.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-82">
                <Check className="w-6 h-6 text-rose-600 flex-shrink-0 mt-1" data-id="element-83" />
                <p className="text-lg text-gray-700" data-id="element-84">
                  Porque são 40 ideias diferentes. É matematicamente impossível
                  você não gostar de pelo menos 5.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-85">
                <Check className="w-6 h-6 text-rose-600 flex-shrink-0 mt-1" data-id="element-86" />
                <p className="text-lg text-gray-700" data-id="element-87">
                  Porque eu quero que você se sinta 100% segura e confiante na
                  sua decisão.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-rose-100 border-l-4 border-rose-500 p-6 rounded-lg" data-id="element-88">
            <p className="text-xl text-gray-800 leading-relaxed" data-id="element-89">
              <span className="font-bold" data-id="element-90">Você não tem nada a perder.</span>{' '}
              Apenas economia, elegância e tranquilidade para ganhar.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}